/**
 * Condition node configuration type and validation
 */

export type ConditionConfigType = {
  expression: string;
  trueBranchLabel?: string;
  falseBranchLabel?: string;
};

export const defaultConditionConfig: ConditionConfigType = {
  expression: '',
  trueBranchLabel: 'Yes',
  falseBranchLabel: 'No',
};

export const validateConditionConfig = (
  config: ConditionConfigType,
): Record<string, string> => {
  const errors: Record<string, string> = {};

  if (!config.expression || config.expression.trim() === '') {
    errors.expression = 'Expression is required';
  }

  return errors;
};

/**
 * Get preview text for the node display
 */
export const getConditionPreviewText = (config: ConditionConfigType): string =>
  config.expression || 'Configure condition';
